export type LongTailPage = {
  slug: string;
  path: string;
  title: string;
  description: string;
  keywords: string[];
  eyebrow: string;
  h1: string;
  intro: string;
  ctaLabel: string;
  sections: Array<{
    heading: string;
    body: string;
  }>;
  faqs: Array<{
    question: string;
    answer: string;
  }>;
  priority: string;
  changefreq: string;
};

export const homeGameHref = "/#modalita-libera";

export const longTailPages: LongTailPage[] = [
  {
    slug: "senza-limiti",
    path: "/senza-limiti/",
    title: "Wordle Italiano Senza Limiti - Gioca Gratis Online",
    description:
      "Gioca a Wordle Italiano senza limiti: avvia nuove partite quando vuoi, prova parole italiane da cinque lettere e torna subito alla modalita libera.",
    keywords: [
      "wordle italiano senza limiti",
      "wordle illimitato italiano",
      "wordle italiano infinito",
      "wordle in italiano senza limiti"
    ],
    eyebrow: "wordle italiano senza limiti",
    h1: "Wordle Italiano senza limiti",
    intro:
      "Una pagina pensata per chi cerca un Wordle in italiano da giocare senza aspettare il puzzle del giorno. Il pulsante porta direttamente alla modalita libera della home.",
    ctaLabel: "Gioca senza limiti",
    sections: [
      {
        heading: "Modalita libera per partite continue",
        body:
          "La ricerca wordle italiano senza limiti nasce da utenti che vogliono iniziare un altro round subito dopo la partita quotidiana. Questa pagina intercetta quell'intento e rimanda al gioco principale."
      },
      {
        heading: "Parole italiane da cinque lettere",
        body:
          "Ogni partita usa parole italiane brevi, facili da digitare su mobile e adatte alla classica griglia in sei tentativi."
      },
      {
        heading: "Quando usare questa pagina",
        body:
          "Usala quando vuoi allenarti, testare nuove parole iniziali o fare piu partite di seguito senza cambiare sito."
      }
    ],
    faqs: [
      {
        question: "Posso giocare a Wordle Italiano senza limiti?",
        answer:
          "Si. Dalla modalita libera puoi avviare una nuova partita quando vuoi."
      },
      {
        question: "La modalita senza limiti usa parole italiane?",
        answer:
          "Si. Le parole sono italiane e hanno cinque lettere, come nella griglia principale."
      }
    ],
    priority: "0.9",
    changefreq: "daily"
  },
  {
    slug: "oggi",
    path: "/oggi/",
    title: "Wordle Italiano Oggi - Parola del Giorno e Gioco Online",
    description:
      "Apri Wordle Italiano oggi, gioca la parola del giorno e passa alla modalita libera se vuoi continuare con altre parole italiane.",
    keywords: [
      "wordle italiano oggi",
      "parola wordle italiano oggi",
      "soluzione wordle italiano oggi",
      "wordle in italiano oggi"
    ],
    eyebrow: "wordle italiano oggi",
    h1: "Wordle Italiano oggi",
    intro:
      "Per chi cerca il puzzle italiano del giorno: questa pagina chiarisce l'intento e porta subito alla griglia principale della home.",
    ctaLabel: "Gioca la parola di oggi",
    sections: [
      {
        heading: "Parola del giorno",
        body:
          "Il formato giornaliero e il punto di ingresso piu naturale per chi cerca wordle italiano oggi. La home apre il gioco con la parola quotidiana pronta."
      },
      {
        heading: "Indizi senza rovinare la partita",
        body:
          "Puoi iniziare con parole ricche di vocali e usare il feedback della griglia per restringere le possibilita senza cercare subito la soluzione."
      },
      {
        heading: "Dopo il round quotidiano",
        body:
          "Se vuoi continuare, la modalita libera permette di giocare altre parole italiane senza aspettare il giorno successivo."
      }
    ],
    faqs: [
      {
        question: "Dove gioco il Wordle Italiano di oggi?",
        answer:
          "Il pulsante della pagina porta alla home, dove la modalita Oggi e gia disponibile."
      },
      {
        question: "Mostrate subito la soluzione di oggi?",
        answer:
          "No. La pagina privilegia il gioco e gli indizi generali, cosi la partita resta utile e non viene rovinata."
      }
    ],
    priority: "0.9",
    changefreq: "daily"
  },
  {
    slug: "parole-5-lettere",
    path: "/parole-5-lettere/",
    title: "Parole Italiane 5 Lettere per Wordle Italiano",
    description:
      "Trova idee per parole italiane di 5 lettere, migliori parole iniziali e strategie per migliorare a Wordle Italiano online.",
    keywords: [
      "parole italiane 5 lettere",
      "parole wordle italiano",
      "wordle italiano parole",
      "migliori parole wordle italiano"
    ],
    eyebrow: "parole wordle italiano",
    h1: "Parole italiane di 5 lettere per Wordle",
    intro:
      "Una pagina long-tail per utenti che non cercano solo il gioco, ma vogliono parole iniziali, esempi e criteri per migliorare.",
    ctaLabel: "Prova queste parole",
    sections: [
      {
        heading: "Parole iniziali consigliate",
        body:
          "AMORE, STILE, PORTA, LINEA e CANTO sono buoni tentativi per coprire vocali e consonanti comuni senza sprecare la prima riga."
      },
      {
        heading: "Come scegliere una parola utile",
        body:
          "Una buona parola iniziale evita lettere duplicate, mescola vocali diverse e include consonanti frequenti come R, L, T, N o S."
      },
      {
        heading: "Dal suggerimento alla griglia",
        body:
          "Dopo aver scelto una parola, torna al gioco principale e verifica subito quali lettere sono corrette, presenti o assenti."
      }
    ],
    faqs: [
      {
        question: "Qual e una buona parola iniziale per Wordle Italiano?",
        answer:
          "AMORE e STILE sono utili perche coprono piu vocali e consonanti frequenti."
      },
      {
        question: "Le parole devono avere sempre cinque lettere?",
        answer:
          "Si. La griglia di Wordle Italiano accetta parole italiane di cinque lettere."
      }
    ],
    priority: "0.8",
    changefreq: "weekly"
  },
  {
    slug: "strategie",
    path: "/strategie/",
    title: "Strategie Wordle Italiano - Migliori Parole Iniziali",
    description:
      "Strategie per Wordle Italiano: scegli parole iniziali efficaci, interpreta colori e lettere, poi gioca subito sulla griglia principale.",
    keywords: [
      "strategie wordle italiano",
      "migliore parola per iniziare wordle italiano",
      "migliori parole iniziali wordle italiano",
      "come vincere wordle italiano"
    ],
    eyebrow: "strategie wordle italiano",
    h1: "Strategie per Wordle Italiano",
    intro:
      "Una pagina di supporto per chi vuole migliorare il metodo: meno tentativi casuali, piu lettura dei colori e delle lettere confermate.",
    ctaLabel: "Metti in pratica",
    sections: [
      {
        heading: "Primo tentativo",
        body:
          "Parti con una parola che usa vocali diverse e consonanti frequenti. Evita doppie lettere finche non hai raccolto abbastanza informazioni."
      },
      {
        heading: "Secondo tentativo",
        body:
          "Se molte lettere sono grigie, cambia famiglia di consonanti. Se hai lettere gialle, spostale in nuove posizioni."
      },
      {
        heading: "Ultimi tentativi",
        body:
          "Quando restano due o tre spazi, pensa ai pattern tipici dell'italiano e non forzare parole rare se esiste una combinazione comune."
      }
    ],
    faqs: [
      {
        question: "Serve una strategia diversa per l'italiano?",
        answer:
          "Si. L'italiano ha molte vocali e pattern ricorrenti, quindi conviene partire da parole che li testano presto."
      },
      {
        question: "Meglio indovinare subito o raccogliere lettere?",
        answer:
          "Nei primi due tentativi conviene raccogliere informazioni; poi puoi stringere sulla parola finale."
      }
    ],
    priority: "0.8",
    changefreq: "weekly"
  },
  {
    slug: "archivio",
    path: "/archivio/",
    title: "Archivio Wordle Italiano - Parole e Partite Precedenti",
    description:
      "Archivio Wordle Italiano per chi cerca parole precedenti, partite vecchie e un modo rapido per tornare al gioco online.",
    keywords: [
      "archivio wordle italiano",
      "wordle italiano archivio",
      "wordle italiano parole precedenti",
      "vecchi wordle italiano"
    ],
    eyebrow: "archivio wordle italiano",
    h1: "Archivio Wordle Italiano",
    intro:
      "Una pagina pensata per intercettare ricerche su parole precedenti e vecchie partite, con collegamento diretto al gioco principale.",
    ctaLabel: "Vai al gioco",
    sections: [
      {
        heading: "Perche cercare l'archivio",
        body:
          "Molti giocatori vogliono recuperare partite passate, confrontare parole precedenti o allenarsi prima del nuovo round quotidiano."
      },
      {
        heading: "Allenamento e memoria",
        body:
          "Anche senza mostrare una lista infinita di soluzioni, questa pagina aiuta a collegare l'intento archivio alla modalita libera del gioco."
      },
      {
        heading: "Prossima espansione",
        body:
          "La struttura e pronta per aggiungere in futuro pagine giornaliere o raccolte di parole, senza cambiare il sito principale."
      }
    ],
    faqs: [
      {
        question: "Esiste un archivio completo di Wordle Italiano?",
        answer:
          "Questa pagina prepara l'ingresso archivio e collega al gioco. La raccolta completa puo essere ampliata con pagine giornaliere."
      },
      {
        question: "Posso usare la modalita libera come archivio di allenamento?",
        answer:
          "Si. La modalita libera e utile per fare piu partite e testare parole diverse."
      }
    ],
    priority: "0.7",
    changefreq: "weekly"
  }
];

export function getLongTailPage(pathname: string): LongTailPage | undefined {
  const normalized = pathname.endsWith("/") ? pathname : `${pathname}/`;
  return longTailPages.find((page) => page.path === normalized);
}
